import { Injectable } from "@angular/core";
import { Adapter } from "@core/adapter";
import { AddressModel } from "../address.model";



export class OrganisationProfileAddress{
  constructor(
    public id:string,
    public name:string = "",
    public phoneNumber:string  = "",
    public email:string  = "",
    public address:AddressModel
  ){}
}


@Injectable({
  providedIn: 'root'
})

export class OrganisationProfileAddressAdapter implements Adapter<OrganisationProfileAddress> {
  adapt(item: any): OrganisationProfileAddress {
    return new OrganisationProfileAddress(
      item.id,
      item.name,
      item.phoneNumber,
      item.emailAddress,
      item.address,
    );
  }
}
